//* 코치 프로필 관련 API
//  2025.01.27
//  희문

import * as BaseApi from "api/Base.api";
import { IUserKoach } from "api/interfaces/user.interface";

const BASE_URL = "/koach";

//* 코치 프로필 정보 응답 인터페이스
export interface IGetKoachProfileResponse {
    info: IUserKoach & {
        profileImageInfo?: {
            id: string;
            url: string;
        };
        bgImageInfo?: {
            id: string;
            url: string;
        };
    };
}

//* 코치 프로필 정보 조회
//  2025.01.27
//  희문
//* Params
//  none (현재 로그인한 코치의 정보 조회)
export const getKoachProfile = async (): Promise<IGetKoachProfileResponse> => {
    const url = `${BASE_URL}/info/koach`;
    return await BaseApi.get(url);
};

//* 코치 배경 색상 업데이트
//  2025.01.27
//  희문
//* Params
//  bgColorHexCode: 배경 색상 hex 코드 (# 없이)
export const updateKoachBgColor = async (bgColorHexCode: string): Promise<void> => {
    const url = `${BASE_URL}/info/koach/bg-color`;
    return await BaseApi.put(url, { bgColorHexCode });
};

//* 코치 배경 이미지 업데이트 응답 인터페이스
export interface IUpdateKoachBgImageResponse {
    success: boolean;
    bgImageInfo: {
        id: string;
        url: string | null;
    };
}

//* 코치 배경 이미지 업데이트
//  2025.01.27
//  희문
//* Params
//  bgImageId: 배경 이미지 ID
export const updateKoachBgImage = async (bgImageId: string): Promise<IUpdateKoachBgImageResponse> => {
    const url = `${BASE_URL}/info/koach/bg-image`;
    const response = await BaseApi.put(url, { bgImageId });
    // BaseApi.put은 { status, data } 형태를 반환
    // 서버 응답: { message: "성공", data: { success: true, bgImageInfo: {...} } }
    // 따라서 response.data.data에서 실제 데이터 추출
    return response.data.data;
};

//* 코치 프로필 이미지 업데이트 응답 인터페이스
export interface IUpdateKoachProfileImageResponse {
    success: boolean;
    profileImageInfo: {
        id: string;
        url: string | null;
    };
}

//* 코치 프로필 이미지 업데이트
//  2025.01.27
//  희문
//* Params
//  profileImageId: 프로필 이미지 ID
export const updateKoachProfileImage = async (profileImageId: string): Promise<IUpdateKoachProfileImageResponse> => {
    const url = `${BASE_URL}/info/koach/profile-image`;
    const response = await BaseApi.put(url, { profileImageId });
    return response.data.data;
};

//* 코치 닉네임 업데이트
//  2025.01.27
//  희문
//* Params
//  nickname: 닉네임
export const updateKoachNickname = async (nickname: string): Promise<void> => {
    const url = `${BASE_URL}/info/koach/nickname`;
    return await BaseApi.put(url, { nickname });
};

//* 코치 핸들러 업데이트
//  2025.01.27
//  희문
//* Params
//  handler: 핸들러
export const updateKoachHandler = async (handler: string): Promise<void> => {
    const url = `${BASE_URL}/info/koach/handler`;
    return await BaseApi.put(url, { handler });
};

//* 코치 자기소개 업데이트
//  2025.01.27
//  희문
//* Params
//  introduction: 자기소개
export const updateKoachIntroduction = async (introduction: string): Promise<void> => {
    const url = `${BASE_URL}/info/koach/introduction`;
    return await BaseApi.put(url, { introduction });
};

//* 코치 자기소개 AI 생성 응답 인터페이스
export interface IGenerateIntroductionResponse {
    introduction: string;
}

//* 코치 자기소개 AI 생성
//  2025.01.27
//  희문
//* Params
//  keywords: 현재 입력된 키워드
export const generateKoachIntroduction = async (keywords?: string): Promise<IGenerateIntroductionResponse> => {
    const url = `${BASE_URL}/info/koach/introduction/generate`;
    const response = await BaseApi.post(url, { keywords: keywords || '' });
    // BaseApi.post는 { status, data } 형태를 반환
    // 서버 응답: { message: "성공", data: { introduction: "..." } }
    // 따라서 response.data.data에서 실제 데이터 추출
    if (!response || !response.data || !response.data.data) {
        throw new Error('자기소개 생성 응답이 올바르지 않습니다.');
    }
    return response.data.data;
};

//* 코치 구사 가능한 언어 업데이트
//  2025.01.27
//  희문
//* Params
//  languageList: 언어 정보 배열 [{ languageCode: string, level: number }]
export const updateKoachAvailableLanguages = async (languageList: Array<{ languageCode: string; level: number }>): Promise<void> => {
    const url = `${BASE_URL}/info/koach/available-languages`;
    return await BaseApi.put(url, { languageList });
};


